<a
  (click)="menu.isOpen = !menu.isOpen"
  [class.sc-nav-items__list-item-link--open]="menu.isOpen"
  class="sc-nav-items__list-item-link"
>
  <sc-icon
    *ngIf="menu.icon"
    class="sc-nav-items__list-item-icon"
    [icon]="menu.icon" size="0_75"></sc-icon>
  <span
    *ngIf="!menu.icon"
    class="sc-nav-items__list-item-icon-placeholder">
      </span>
  <div class="sc-nav-items__list-item-label">
    {{menu.label}}
  </div>
  <sc-icon
    class="sc-nav-items__list-item-icon-open"
    [icon]="menu.isOpen ? 'arrow-down' : 'arrow-right'" size="0_5"></sc-icon>
</a>
<sc-nav-items
  [ngClass]="{'sub-item-nested': !firstLevel}"
  class="sc-nav-items__submenu sub-item"
  [class.sc-nav-items__submenu--open]="menu.isOpen"
  *ngIf="menu.isOpen"
  [highlightActive]="highlightActive"
  [menu]="menu"
  (itemClicked)="itemClicked.emit($event)"
>
</sc-nav-items>
